import React, {Component} from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
import classes from './LoadingSpinner.module.css'

class LoadingSpinner extends Component {
  render () {
    return (
      <div className={classes.container}>
        <div className={classes.progress}>
          <CircularProgress className={classes.icon} mode="indeterminate" size={200} thickness={2} />
        </div>
      </div>
    );
  }
};

export default LoadingSpinner;